import { Fund } from 'src/components/Exchange/types';
import {
  FundNoteDistributeCollege,
  COLLEGE_PLAN_TYPES,
  DELIVERY_MAIL_CHECK,
  SystemCode,
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
} from 'src/settings/settings';

import {
  checkFoundFeaturesByCode,
  DISABLE_ON_MATCH,
  isTransactionRestrictedForFundingBank,
  missingRedemptionFeature,
  updateFundNote,
} from '../shared/shared-fund-notes-utility';

export function updateCollegeDistributeFundNotesForFund(
  deliveryMethod,
  fund: Fund,
  isCheckWithMultipleAddress: boolean,
  selectedBankAgreementMap,
  selectedBene
) {
  // Address change pending
  updateFundNote(
    fund,
    isCheckWithMultipleAddress && fund.restrictedByAddressChange,
    FundNoteDistributeCollege.ADDRESS_CHANGE_PENDING,
    DISABLE_ON_MATCH
  );

  // Address undeliverable
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(fund, SystemCode.STOP_MAIL_ID) &&
      !fund.addressChangedSameDay &&
      deliveryMethod !== DELIVERY_MAIL_CHECK_TO_SCHOOL,
    FundNoteDistributeCollege.ADDRESS_UNDELIVERABLE,
    DISABLE_ON_MATCH
  );

  // AK529 disable ACT portfolio
  updateFundNote(
    fund,
    fund.productType === COLLEGE_PLAN_TYPES.ALASKA_529 &&
      fund.trpCode === 'CSA',
    FundNoteDistributeCollege.AK529_ACT,
    DISABLE_ON_MATCH
  );

  // One Beneficiary Per Distribution to School allowed
  updateFundNote(
    fund,
    deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL &&
      selectedBene &&
      selectedBene !== fund.formattedEntityNames,
    FundNoteDistributeCollege.ONE_BENE_PER_DTS,
    DISABLE_ON_MATCH
  );

  // Bank not linked
  updateFundNote(
    fund,
    fund.isFundAssociable &&
      deliveryMethod !== DELIVERY_MAIL_CHECK &&
      deliveryMethod !== DELIVERY_MAIL_CHECK_TO_SCHOOL,
    FundNoteDistributeCollege.BANK_NOT_LINKED,
    DISABLE_ON_MATCH
  );

  // Cannot link bank
  updateFundNote(
    fund,
    isTransactionRestrictedForFundingBank(fund, selectedBankAgreementMap) &&
      deliveryMethod !== DELIVERY_MAIL_CHECK &&
      deliveryMethod !== DELIVERY_MAIL_CHECK_TO_SCHOOL,
    FundNoteDistributeCollege.CANNOT_LINK_BANK,
    DISABLE_ON_MATCH
  );

  // Check distribution unavailable
  updateFundNote(
    fund,
    missingRedemptionFeature(fund, deliveryMethod) === 'CHECK',
    FundNoteDistributeCollege.CHECK_DISTRIBUTION_UNAVAILABLE,
    DISABLE_ON_MATCH
  );

  // Direct deposit unavailable (ACH)
  updateFundNote(
    fund,
    missingRedemptionFeature(fund, deliveryMethod) === 'ACH',
    FundNoteDistributeCollege.DIRECT_DEPOSIT_UNAVAILABLE,
    DISABLE_ON_MATCH
  );

  // Stop transfer
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(fund, SystemCode.STOP_TRANSFER_ID) ||
      (fund['529FundMerged'] && fund.equityAsOf > 0),
    FundNoteDistributeCollege.STOP_TRANSFER,
    DISABLE_ON_MATCH
  );

  // Transaction pending
  updateFundNote(
    fund,
    fund.hasPendingTransaction && fund.redeemableFundDollars !== 0,
    FundNoteDistributeCollege.TRANSACTION_PENDING
  );

  // Transaction pending that will redeem all
  updateFundNote(
    fund,
    fund.hasPendingTransaction && fund.redeemableFundDollars === 0,
    FundNoteDistributeCollege.TRANSACTION_PENDING_ALL,
    DISABLE_ON_MATCH
  );

  // Unavailable for online redemption
  updateFundNote(
    fund,
    missingRedemptionFeature(fund, deliveryMethod) === 'all' &&
      fund.trpCode !== 'CSA',
    FundNoteDistributeCollege.UNAVAILABLE_ONLINE,
    DISABLE_ON_MATCH
  );

  // Has uncollected units
  updateFundNote(
    fund,
    fund.hasUncollectedShares,
    FundNoteDistributeCollege.UNCOLLECTED_UNITS
  );

  // Wire distribution unavailable online
  updateFundNote(
    fund,
    missingRedemptionFeature(fund, deliveryMethod) === 'Wire',
    FundNoteDistributeCollege.WIRE_REDEMPTION_UNAVAILABLE,
    DISABLE_ON_MATCH
  );
}
